import { Navigate } from "react-router-dom";

import { Navigation } from "fond/settings";
import { PageContent } from "fond/widgets";

const Settings: React.FC = () => {
  // Since this root page only redirects, use the title
  // of the target page to avoid content flickering
  return <PageContent title="Profile Settings" mainContent={<Navigate to="/settings/profile" replace />} navigation={<Navigation />} />;
};

export default Settings;
